/*
---
covers:
  - frontend/src/pages/empresa/proveedores/proveedores.tsx
  - frontend/src/hooks/empresa/proveedores/use-proveedores.ts
  - backend/app/empresa/proveedores/routers.py
  - backend/app/empresa/proveedores/core/**
  - backend/app/empresa/proveedores/service.py
revisado: 2026-09-30
---
*/
import type {ManualSeccion} from '../types'

export const seccion: ManualSeccion = {
  id: 'proveedores',
  titulo: 'Proveedores y contratistas',
  resumen:
    'El directorio de proveedores y contratistas de tu empresa: alta, edición, y sus evaluaciones de SST (afiliación ARL, SG-SST propio, cumplimiento) que respaldan los estándares 2.9.1/2.10.1.',
  enCorto: [
    'El directorio de proveedores y contratistas.',
    'Los das de alta y evalúas su SST.',
    'Respalda los estándares 2.9.1 y 2.10.1.',
    'Una evaluación por proveedor y por año.',
  ],
  replayId: 'proveedores',
  operaciones: [
    {
      id: 'crear-proveedor',
      titulo: 'Registrar un proveedor o contratista',
      como: 'El botón «Nuevo proveedor» abre un formulario con tipo (Proveedor/Contratista), NIT, razón social, servicio que presta y un contacto opcional.',
      porQueImporta:
        'Es el directorio que sustenta que tu empresa conoce y gestiona a quienes le prestan servicios — la base sobre la que se construyen sus evaluaciones de SST.',
    },
    {
      id: 'registrar-evaluacion-con-soporte',
      titulo: 'Registrar una evaluación de SST con su soporte',
      como: 'Al abrir un proveedor de la lista, el botón «Nueva evaluación» pide el estándar (2.9.1 o 2.10.1), qué se verificó (afiliación ARL, SG-SST propio o cumplimiento), la fecha, el resultado (Cumple/No cumple) y, opcionalmente, el archivo que lo soporta.',
      porQueImporta:
        'Deja registro verificable de que evaluaste al proveedor — no basta con tenerlo en el directorio, la resolución exige constancia de la evaluación misma.',
    },
    {
      id: 'ver-respaldo-derivado-en-checklist',
      titulo: 'Ver el respaldo que tus evaluaciones le dan al checklist',
      como: 'Cuando TODOS tus proveedores activos tienen una evaluación vigente (del último año) que verificó lo mismo, el estándar correspondiente (2.9.1 con «cumplimiento», 2.10.1 con «afiliación ARL») aparece «Sugerido» en el checklist, con su chip y el botón «Confirmar».',
      porQueImporta:
        'No repites en el checklist lo que ya registraste aquí — Kairos deriva el cumplimiento de tus evaluaciones reales y tú solo confirmas; si falta evaluar a alguien, el sugerido no aparece.',
    },
  ],
}
